import React from 'react';
import { TargetIcon, MapPinIcon, PenToolIcon, DollarSignIcon } from 'lucide-react';
export function CourseInfo() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-276">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-277">
        <div className="mb-12" data-id="element-278">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-279">
            Course Information
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-280">
            <div className="space-y-6" data-id="element-281">
              <div className="flex items-start gap-4" data-id="element-282">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(30,61,47,0.08)'
              }} data-id="element-283">
                  <TargetIcon size={20} style={{
                  color: '#1e3d2f'
                }} data-id="element-284" />
                </div>
                <div data-id="element-285">
                  <h3 className="text-base font-bold uppercase mb-1" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#1e3d2f'
                }} data-id="element-286">
                    Allowed Equipment
                  </h3>
                  <p className="text-base" style={{
                  color: '#2a2a2a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-287">
                    Long bows, compound bows, and cross bows are allowed.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-288">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(30,61,47,0.08)'
              }} data-id="element-289">
                  <MapPinIcon size={20} style={{
                  color: '#1e3d2f'
                }} data-id="element-290" />
                </div>
                <div data-id="element-291">
                  <h3 className="text-base font-bold uppercase mb-1" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#1e3d2f'
                }} data-id="element-292">
                    Course Entry
                  </h3>
                  <p className="text-base" style={{
                  color: '#2a2a2a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-293">
                    Course entry is from the outdoor range parking lot.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-294">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(30,61,47,0.08)'
              }} data-id="element-295">
                  <PenToolIcon size={20} style={{
                  color: '#1e3d2f'
                }} data-id="element-296" />
                </div>
                <div data-id="element-297">
                  <h3 className="text-base font-bold uppercase mb-1" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#1e3d2f'
                }} data-id="element-298">
                    Sign-In Required
                  </h3>
                  <p className="text-base" style={{
                  color: '#2a2a2a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-299">
                    All members and guests must sign in and have indemnification
                    forms completed at the gate to the outdoor ranges.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-300">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(30,61,47,0.08)'
              }} data-id="element-301">
                  <DollarSignIcon size={20} style={{
                  color: '#1e3d2f'
                }} data-id="element-302" />
                </div>
                <div data-id="element-303">
                  <h3 className="text-base font-bold uppercase mb-1" style={{
                  fontFamily: 'Oswald, sans-serif',
                  color: '#1e3d2f'
                }} data-id="element-304">
                    Fee Payment
                  </h3>
                  <p className="text-base" style={{
                  color: '#2a2a2a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-305">
                    Course fees are to be deposited in the box at the entry to
                    the archery course, <strong data-id="element-306">not</strong> the box at the
                    sign-in station.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}